<template>
  <SlideInFromLeftTransition>
    <FocusTrap
      :active="isSideNavigationOpen && isMobileOrTablet"
      :escape-deactivates="true"
      :return-focus-on-deactivate="true"
      :click-outside-deactivates="true"
      @deactivate="close"
    >
      <nav
        v-if="isSideNavigationOpen"
        class="fixed inset-0 z-50 overflow-hidden overflow-y-auto bg-white"
        :class="{ 'animate-pulse': fetching }"
      >
        <div class="h-full">
          <div
            class="fixed top-0 z-10 flex w-full justify-between bg-white px-3 py-4"
          >
            <LogoMobile />
            <button data-test-id="close-mobile-menu-button" @click="close">
              <IconClose class="fill-current size-6" />
            </button>
          </div>
          <div class="flex h-full flex-col justify-between">
            <div class="mt-16 flex flex-col overflow-y-auto px-4">
              <MobileNavigationAccordion
                :navigation-items="navigationItems"
                @click:item="trackClickAndClose"
              />
            </div>
            <AgsLazy ssr>
              <template #lazy="{ visible }">
                <LazyMobileMainMenu
                  v-if="visible"
                  :blok="blok"
                  @click:link="close()"
                />
              </template>
            </AgsLazy>
          </div>
        </div>
      </nav>
    </FocusTrap>
  </SlideInFromLeftTransition>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue'
import type { Category } from '@scayle/storefront-nuxt'
import { FocusTrap } from 'focus-trap-vue'
import { useRoute } from '#app/composables/router'
import type { SbNavigation } from '~/cms/storyblok/types/storyblok.d.ts'
import useUiState from '~/composables/ui/useUiState'
import { useDeviceType } from '~/composables/useDeviceType'
import useWatch from '~/composables/useWatch'
import { useNavigationMapping } from '~/composables/useNavigationMapping'

const props = defineProps({
  rootCategories: {
    type: Array as PropType<Category[]>,
    default: () => [],
  },
  fetching: {
    type: Boolean,
    required: true,
  },
  blok: {
    type: Object as PropType<SbNavigation>,
    default: () => {},
  },
})

const route = useRoute()
const { isSideNavigationOpen, closeSideNavigation: close } = useUiState()
const { isMobileOrTablet } = useDeviceType()
useWatch(
  () => route,
  () => !isMobileOrTablet.value && close(),
)

const { getNavigationItems } = useNavigationMapping()

const navigationItems = computed(() => {
  const activeStoryblokItems = props.blok?.MainNavigation || []
  return getNavigationItems(activeStoryblokItems, props.rootCategories)
})

const trackClickAndClose = (path: string) => {
  if (path) {
    navigateTo(path)
    close()
  }
}
</script>
